<form novalidate #manageEmailsForm="ngForm" (submit)="saveEmail($event)">
  <div class="row">
    <div class="col-xl-6 manage-col-left">
      <app-card [title]="'admin.emails.manage.settings'|translate">
        <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
          <div class="mb-2"><strong>{{'admin.emails.manage.email_details'|translate}} </strong></div>
            <div class="form-group row">
              <div class="form-group form-default form-static-label col-6">
                <label class="float-label">{{'doctrine.emails.event'|translate}}</label>
                   <input class="form-control"
                         placeholder="{{'doctrine.emails.event'|translate}}"
                         name="event"
                         #event="ngModel"
                          disabled
                         [(ngModel)]="email.event" >
              </div>
              <div class="form-group form-default form-static-label col-6">
                <label class="float-label">{{'doctrine.attributes.language'|translate}}</label>
                <ng-select [(ngModel)]="email.language" name="select" disabled>
                  <ng-option [value]="language.id" *ngFor="let language of languages">{{language.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <div class="form-group form-default form-static-label col-6">
                <label class="float-label">{{'doctrine.emails.subject'|translate}}</label>
                   <input class="form-control"
                         placeholder="{{'doctrine.emails.subject'|translate}}"
                         name="subject"
                         #subject="ngModel"
                         (keyup)="updateBody('email')"
                         [(ngModel)]="email.subject" required>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="subject.invalid && subject.dirty && subject.errors?.required">{{'errors.required'|translate}}</div>
              </div>
              <div class="form-group form-default form-static-label col-6">
                <label class="float-label">{{'doctrine.emails.status'|translate}}</label>
                <ng-select class="ng-select" name="active" #active="ngModel" [(ngModel)]="email.active" [clearable]="false" >
                  <ng-option [value]="true">{{'global.active'|translate}}</ng-option>
                  <ng-option [value]="false">{{'global.inactive'|translate}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="form-group row">
              <div class="form-group form-default form-static-label col-6">
                <label class="float-label">{{'doctrine.emails.pre_header'|translate}}</label>
                <input class="form-control"
                       placeholder="{{'doctrine.emails.pre_header'|translate}}"
                       name="preheader"
                       #preheader="ngModel"
                       [(ngModel)]="email.preHeader">
              </div>
              <div class="form-group form-default form-static-label col-6">
                <label class="float-label">{{'doctrine.emails.bcc'|translate}}</label>
                <div class="email-chips-container">
                  <div class="email-chips">
                    <span class="email-chip" *ngFor="let email of bcc">
                      {{email.value}}
                      <span class="remove-chip" (click)="removeEmail(email, 'bcc')">&times;</span>
                    </span>
                  </div>
                  <input class="form-control" 
                         type="text"
                         [(ngModel)]="bccInput"
                         name="bccInput"
                         #bccField="ngModel"
                         [email]="true"
                         (keydown.enter)="$event.preventDefault()"
                         (keyup.enter)="addEmail($event, 'bcc')"
                         (keyup.comma)="addEmail($event, 'bcc')"
                         [placeholder]="bcc.length ? '+' : ('doctrine.emails.bcc'|translate)">
                </div>
                <div class="messages text-danger" *ngIf="bccField.invalid && bccField.dirty && bccField.errors?.email">
                  {{errorMessages.email}}
                </div>
              </div>
            </div>
        </div>
        <div class="mb-2"><strong>{{'admin.emails.manage.body_information'|translate}} </strong></div>
        <nav ngbNav #nav="ngbNav" [(activeId)]="activeId" class="nav nav-tabs">
          <ng-container *ngFor="let tab of tabs;let i=index">
            <div [ngbNavItem]="i">
              <a ngbNavLink class="nav-link">{{tab.title}}</a>
              <ng-template ngbNavContent>
                <div [@fadeInOutTranslate] class="m-t-15">
                  <quill-editor [modules]="modules"  (onContentChanged)="updateBody('email')" [name]="'content'+i" [(ngModel)]="email.bodyMapping[tab.title]" ></quill-editor>
                </div>
              </ng-template>
            </div>
          </ng-container>
          <div ngbNavItem *ngIf="attachments.length > 0">
            <a ngbNavLink class="nav-link">{{'admin.emails.manage.attachment'|translate}}</a>
            <ng-template ngbNavContent>
              <div [@fadeInOutTranslate] class="m-t-15">
                <ng-container>
                  <ul>
                    <li *ngFor="let attachment of attachments">
                      <div class="border-checkbox-section">
                        <div class="border-checkbox-group border-checkbox-group-primary">
                          <input type="checkbox" class="border-checkbox" disabled>
                          <label class="border-checkbox-label">{{attachment}}</label>
                        </div>
                      </div>
                    </li>
                  </ul>
                </ng-container>
              </div>
            </ng-template>
          </div>
        </nav>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
        <div class="mb-2 pt-2"><strong>{{'admin.emails.manage.tokens'|translate}} </strong></div>
        <div class="row mb-2 pt-2">
          <div class="col-md-6"><b>Name</b></div>
          <div class="col-md-6"><b>Token</b></div>
        </div>
        <div ngbAccordion #acc="ngbAccordion" class="ngb-accordion">
          <div ngbAccordionItem id="ngb-close-p{{i}}" *ngFor="let root of listTokens; let i = index; first as isFirst">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton>{{root.display}}</button>
            </h2>
            <div ngbAccordionCollapse class="p-3">
              <div *ngFor="let t of root.list" class="row">
                <div class="col-md-6">{{t.description}}</div>
                <div class="col-md-6 cursor-pointer" [copy-clipboard]="t.name" (copied)="clipboardUpdated()"
                     ngbTooltip="{{'admin.emails.manage.click_to_copy' | translate}}" container="body" placement="left">{{t.name}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
    <div class="col-xl-6 manage-col-right">
      <app-card [title]="'admin.emails.manage.email_preview'|translate">
        <div class="box box-default min-margin">
          <div class="box-body">
            <div class="form-group">
              <div class="manage-title">
                <ng-container *ngIf="!iframeUrl">{{'admin.emails.manage.email_preview_loading'|translate}}
                </ng-container>
                <iframe *ngIf="iframeUrl" [src]="iframeUrl" width="100%" height='450px'
                        class="email-preview"></iframe>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-6 manage-col-left">
      <app-card [title]="'admin.emails.manage.email copy'|translate">
        <div class="box box-default min-margin">
          <div class="box-body" dir="ltr">
            <div class="border-checkbox-section">
              <div class="border-checkbox-group border-checkbox-group-primary">
                <input type="checkbox" class="border-checkbox" id="checkbox01" [(ngModel)]="email.hasCopy" name="copy"  #copy="ngModel">
                <label for="checkbox01" class="border-checkbox-label">{{'admin.emails.manage.send copy of email'|translate}}</label>
              </div>
            </div>
            <ng-container *ngIf="email.hasCopy">
              <div class="form-group row">
                <div class="form-group form-default form-static-label col-6">
                  <label class="float-label">{{'doctrine.emails.to'|translate}}</label>
                  <input class="form-control"
                         placeholder="{{'doctrine.emails.to'|translate}}"
                         name="to"
                         email
                         #to="ngModel"
                         [(ngModel)]="email.copyTo" required>
                  <span class="form-bar"></span>
                  <div class="messages text-danger" *ngIf="to.invalid && to.dirty && to.errors?.email">{{'errors.invalid'|translate}}</div>
                  <div class="messages text-danger" *ngIf="to.invalid && to.dirty && to.errors?.required">{{'errors.required'|translate}}</div>
                </div>
                <div class="form-group form-default form-static-label col-6">
                  <label class="float-label">{{'doctrine.emails.cc'|translate}}</label>
                  <div class="email-chips-container">
                    <div class="email-chips">
                      <span class="email-chip" *ngFor="let email of copyCc">
                        {{email.value}}
                        <span class="remove-chip" (click)="removeEmail(email, 'copyCc')">&times;</span>
                      </span>
                    </div>
                    <input class="form-control" 
                           type="text"
                           [(ngModel)]="copyCcInput"
                           name="copyCcInput"
                           #copyCcField="ngModel"
                           [email]="true"
                           (keydown.enter)="$event.preventDefault()"
                           (keyup.enter)="addEmail($event, 'copyCc')"
                           (keyup.comma)="addEmail($event, 'copyCc')"
                           [placeholder]="copyCc.length ? '+' : ('doctrine.emails.cc'|translate)">
                  </div>
                  <div class="messages text-danger" *ngIf="copyCcField.invalid && copyCcField.dirty && copyCcField.errors?.email">
                    {{errorMessages.email}}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group form-default form-static-label col-6">
                  <label class="float-label">{{'doctrine.emails.subject'|translate}}</label>
                  <input class="form-control"
                         placeholder="{{'doctrine.emails.subject'|translate}}"
                         name="copySubject"
                         #copySubject="ngModel"
                         (keyup)="updateBody('child')"
                         [(ngModel)]="email.copySubject" required>
                  <span class="form-bar"></span>
                  <div class="messages text-danger" *ngIf="copySubject.invalid && copySubject.dirty && copySubject.errors?.required">{{'errors.required'|translate}}</div>
                </div>
                <div class="form-group form-default form-static-label col-6">
                  <label class="float-label">{{'doctrine.emails.pre_header'|translate}}</label>
                  <input class="form-control"
                         placeholder="{{'doctrine.emails.pre_header'|translate}}"
                         name="copyPreHeader"
                         #copyPreHeader="ngModel"
                         [(ngModel)]="email.copyPreHeader">
                </div>
              </div>
              <div class="mb-2"><strong>{{'admin.emails.manage.body_information'|translate}}</strong></div>
              <nav ngbNav #tabs="ngbNav" class="nav nav-tabs">
                <ng-container *ngFor="let tab of copyTabs;let i=index">
                  <div ngbNavItem>
                    <a ngbNavLink class="nav-link">{{tab.title}}</a>
                    <ng-template ngbNavContent>
                      <div [@fadeInOutTranslate] class="m-t-15">
                        <ng-container *ngIf="!tab.hidden">
                          <quill-editor #editor [modules]="modules" (onContentChanged)="updateBody('child')" [name]="'content_copy'+i" [(ngModel)]="email.copyBodyMapping[tab.title]" ></quill-editor>
                        </ng-container>
                      </div>
                    </ng-template>
                  </div>
                </ng-container>
                <div ngbNavItem *ngIf="attachments.length > 0">
                  <a ngbNavLink class="nav-link">{{'admin.emails.manage.attachment'|translate}}</a>
                  <ng-template ngbNavContent>
                    <div [@fadeInOutTranslate] class="m-t-15">
                      <ng-container>
                        <ul>
                          <li *ngFor="let attachment of attachments">
                            <div class="border-checkbox-section">
                              <div class="border-checkbox-group border-checkbox-group-primary">
                                <input type="checkbox" class="border-checkbox" disabled>
                                <label class="border-checkbox-label">{{attachment}}</label>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </ng-container>
                    </div>
                  </ng-template>
                </div>
              </nav>
              <div [ngbNavOutlet]="tabs" class="mt-2"></div>
              <div class="mb-4"><strong>{{'admin.emails.manage.tokens'|translate}} </strong></div>
              <div ngbAccordion #acc="ngbAccordion" class="ngb-accordion">
                <div ngbAccordionItem id="ngb-close-p{{i}}" *ngFor="let root of listTokens; let i = index; first as isFirst">
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>{{root.display}}</button>
                  </h2>
                  <div ngbAccordionCollapse class="p-3">
                    <div *ngFor="let t of root.list" class="row">
                      <div class="col-md-6">{{t.description}}</div>
                      <div class="col-md-6 cursor-pointer" [copy-clipboard]="t.name" (copied)="clipboardUpdated()"
                           ngbTooltip="{{'admin.emails.manage.click_to_copy' | translate}}" container="body" placement="left">{{t.name}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </app-card>
    </div>
    <div class="col-xl-6 manage-col-right" *ngIf="email.hasCopy">
        <app-card [title]="'admin.emails.manage.email_preview'|translate">
          <div class="box box-default min-margin">
            <div class="box-body">
              <div class="form-group">
                <div class="manage-title">
                  <ng-container *ngIf="!iframeUrlCopy">{{'admin.emails.manage.email_preview_loading'|translate}}
                  </ng-container>
                  <iframe *ngIf="iframeUrlCopy" [src]="iframeUrlCopy" width="100%" height='450px'
                          class="email-preview"></iframe>
                </div>
              </div>
            </div>
          </div>
        </app-card>
      </div>
  </div>
  <div class="row">
    <div class="col-xl-6 manage-col-left">
      <app-card [title]="'admin.emails.manage.email_attachments'|translate">
        <div class="box box-default min-margin">
          <div class="box-body">
            <app-file-uploader
              [(ngModel)]="email.attachments"
              [ngModelOptions]="{standalone: true}"
              label="{{'admin.service_request.files' | translate}}"
              description="{{'validators.file' | translate}}"
              accept=".png,.gif,.jpg,.xls,.xlsx,.doc,.docx,.pdf,.mp4,.webm,.mov,.wmv,.avi,.mkv"
              scope="dealer-system"
              bupload="serviceRequest.files"
              fieldName="files"
              [queueLimit]="5"
            ></app-file-uploader>
          </div>
        </div>
      </app-card>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-6 text-end">
      <button (click)="backToList()"  class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
      <button [disabled]="manageEmailsForm.invalid"  class="btn btn-primary ripple light" type="button" (click)="saveEmail($event)">{{'global.save_changes'|translate}}</button>
    </div>
  </div>
</form>

